import { isMember } from "../../constants"
import * as audit from "./Auditorium"
import * as demand from "./OnDemand"
import * as explZone from "./ExplorationZone"
import * as ExibitionHall from "./ExibitionHall"
import { DisplayAlways, DisplayOnce, Modal, TimeSwitch } from "src/utils/fw"

const ISFModal = (content) => ({
    modalOverrides: {
        dismissHTML: "X",
        dismissStyle: {
            color: "#fff",
            fontSize: "25px"
        },
        style: {
            background: "#8f38de",
            color: "#fff",
            padding: "2em 3.5em",
            borderRadius: "10px",
            textAlign: "center"
        }
    },
    modal: content
})

const auditorium = {
    width: "11.8%",
    height: "17.1%",
    left: "57.4%",
    top: "58.8%",
    label: "Auditorium",
    isExternal: false,
    ...( new Date() < new Date("2022-11-17 08:00:00")
        ? {href: "/Auditorium"}
        : ISFModal(<>
            <h1>The Auditorium is now closed.</h1>
            <p>Please view session recordings in our On-Demand rooms, and be sure to visit the Exhibition Hall and ISF Exploration Zone.</p>
        </>)
    )
}

const exibition = {
    width: "11.8%",
    height: "18.1%",
    left: "26.4%",
    top: "57.8%",
    label: "Exhibition Hall",
    isExternal: false,
    href: ExibitionHall.location
}

const onDemand = {
    width: "6.8%",
    height: "18.1%",
    left: "28.4%",
    top: "37.8%",
    label: "View presentations from Manchester 2022, ISF World Congress",
    isExternal: false,
    ...(isMember ? { href: demand.location } : ISFModal(<h1>This is a Member’s only area. </h1>))
}

const explorationZone = {
    width: "11.8%",
    height: "21.1%",
    left: "57.4%",
    top: "14.8%",
    label: "Exploration Zone",
    isExternal: false,
    ...(isMember ? { href: explZone.location } : ISFModal(<h1>This is a Member’s only area. </h1>))
}

const faq = {
    width: "5.8%",
    height: "15.1%",
    left: "23%",
    top: "76.8%",
    label: "FAQ",
    isExternal: true,
    target: "_blank",
    href: "https://isfcongress.tkeventsregistration.com/2022/faqsvirtual"
}

const helpDesk = {
    width: "17.8%",
    height: "20.1%",
    left: "29.6%",
    top: "74.8%",
    label: "Help Desk",
    isExternal: false,
    onClick: () => {
        return;
    }
}

const newsVideo = {
    width: "13.4%",
    height: "15.2%",
    left: "71.6%",
    top: "50.5%",
    label: "Welcome",
    isExternal: false,
    modalOverrides: {
        dismissHTML: "X",
        dismissStyle: {
            color: "#fff",
            fontSize: "25px"
        },
        style: {
            background: "#8f38de",
            color: "#fff",
            padding: "2em 3.5em",
            borderRadius: "10px",
            height: "44%",
            width: "79vh"
        }
    },
    modal: <div style={{ height: "100%", width: "100%" }}>
        <iframe src="https://player.vimeo.com/video/768690511?h=6c171cd2df&autoplay=1" width="100%" height="100%" frameBorder="0" allow="autoplay; fullscreen" allowfullscreen />
    </div>
}

const highlightsManc = {
    width: "11%",
    height: "12.6%",
    left: "14.55%",
    top: "45.6%",
    label: "Highlights from Manchester",
    isExternal: false,
    modalOverrides: {
        dismissHTML: "X",
        dismissStyle: {
            color: "#fff",
            fontSize: "25px"
        },
        style: {
            background: "#8f38de",
            color: "#fff",
            padding: "2em 3.5em",
            borderRadius: "10px",
            height: "44%",
            width: "79vh"
        }
    },
    modal: <div style={{ height: "100%", width: "100%" }}>
        <iframe src="https://player.vimeo.com/video/769345971?h=e64667f698&autoplay=1" width="100%" height="100%" frameBorder="0" allow="autoplay;" webkitallowfullscreen mozallowfullscreen allowfullscreen />
    </div>
}

export const body = {
    background: `https://assets.swoogo.com/uploads/full/2199147-6374979640d63.jpg`,
    name: "Atrium",
    links: [
        auditorium,
        exibition,
        onDemand,
        explorationZone,
        faq,
        helpDesk,
        newsVideo,
        highlightsManc
    ],
    default: true,
    extras: <TimeSwitch>
        {[
            {
                starts: "2022-10-14 08:45:00 UTC",
                ends: "2022-11-15 07:44:59 UTC",
                id: "welcome",
                content: <>
                    <h1>WELCOME TO MANCHESTER 2022 ONLINE: DAY ONE</h1>
                    <p>Today's keynote speakers are Professor Mo Gawdat and Toomas Ilves.</p>
                    <p>Visit the ISF Exploration Zone to access the latest reports and a wealth of resources available only to our Members and tap into the knowledge of the ISF team.</p>
                    <p>Visit the Exhibition Hall to learn how our sponsors can help you optimise managing your security landscape.</p>
                </>
            },
            {
                starts: "2022-11-15 08:45:00 UTC",
                ends: "2022-11-16 07:44:59 UTC",
                id: "welcome-day-two",
                content: <>
                    <h1>WELCOME TO MANCHESTER 2022 ONLINE: DAY TWO</h1>
                    <p>Today's keynote speakers are Omera Khan and Jamie Bartlett.</p>
                    <p>Visit the ISF Exploration Zone to access the latest reports and a wealth of resources available only to our Members and tap into the knowledge of the ISF team.</p>
                    <p>Visit the Exhibition Hall to learn how our sponsors can help you optimise managing your security landscape.</p>
                    <p>Go to our on-demand room to view yesterday's sessions.</p>
                </>
            },
            {
                starts: "2022-11-16 08:45:00 UTC",
                ends: "2022-11-16 15:59:59 UTC",
                id: "welcome-day-three",
                content: <>
                    <h1>WELCOME TO MANCHESTER 2022 ONLINE: DAY THREE</h1>
                    <p>Today's keynote speakers are Margaret Heffernan and Rahaf Harfoush.</p>
                    <p>Available now - the new ISF Supplier Security WebApp! Join our session at 10:30 for an overview of the wider ISF Supply Chain Security suite and a focus on the latest addition. </p>
                    <p>If you haven't already, you can connect one-to-one with the ISF team in the Exploration Zone.</p>
                    <p>Go to our on-demand room to view previous sessions. All sessions will be available to view on-demand after today's broadcast.</p>
                </>
            },
            {
                starts: "2022-11-16 16:00:00 UTC",
                ends: "2022-11-16 16:10:00 UTC",
                id: "end-day-three",
                content: <>
                    <h1>THANK YOU FOR ATTENDING MANCHESTER 2022 ONLINE</h1>
                    <p>CPE certificates for attendance will be issued automatically approximately three weeks after the event. You will receive an email notification and you will also be able to access your certificate from your ISF profile.</p>
                    <p>The Congress venue will remain open until Wednesday 7th December for you to browse content and watch sessions on demand.</p>
                </>
            },
            {
                starts: "2022-11-16 16:10:00 UTC",
                ends: "2023-11-16 17:00:00 UTC",
                id: "end-day-three",
                onceDay: true,
                content: <>
                    <h1>WELCOME TO MANCHESTER 2022 ONLINE: ON-DEMAND</h1>
                    <p>Visit our On-Demand rooms to view session recordings from Congress in Manchester.</p>
                    <p>Don't forget to visit our ISF Exploration Zone to access the latest reports and a wealth of resources available only to our Members.</p>
                    <p>Visit the Exhibition Hall to learn how our sponsors can help you optimise managing your security landscape.</p>
                    <p>The Online platform will remain open until the 7th of December, 2022.</p>
                    <p>We look forward to seeing you again in 2023!</p>
                </>
            }
        ].map(row => {
            const style = {
                background: "#8f38de",
                color: "#fff",
                padding: "2em 3.5em",
                borderRadius: "10px"
            }

            const content = <DisplayOnce id={row.onceDay === true ? `${new Date().toISOString().split("T")[0]}-${row.id}` : row.id} dismissHTML="X" dismissStyle={{ color: "#fff", fontSize: "25px" }} style={style}>
                {row.content}
            </DisplayOnce>

            return { ...row, content, id: undefined }
        })}
    </TimeSwitch>
}

export const location = "/Atrium"